const LIVE_AWS_S3_BUCKET = 'https://pub-dfcb867cecb84d02a8935ccd39f785f8.r2.dev';
const LIVE_BACK_BASE = 'https://api.votes.chooz-app.com';
const LIVE_FRONT_BASE = 'https://votes.chooz-app.com';

const Consts = {
  basefile: process.env.REACT_APP_FILE_URL || LIVE_AWS_S3_BUCKET,
  baseapi: process.env.REACT_APP_API_URL || `${LIVE_BACK_BASE}/api`,
  baseuri: process.env.REACT_APP_BACK_URL || LIVE_BACK_BASE,
  basedomain: process.env.REACT_APP_FRONT_URL || LIVE_FRONT_BASE,

  statusLabel: {
    CREATED: 'Créée',
    CONFIRMED: 'Confirmée',
    PAID: 'Payée',
    DELIVERING: 'En cours de livraison',
    DELIVERED: 'Livrée',
    CANCELED: 'Annulée'
  },

  taxApplicationLabel: {
    inclusive: 'Inclure au total',
    exclusive: 'Ajouter au total'
  },

  voteStatusLabel: {
    PENDING: { text: 'Non abouti', color: 'gray' },
    PAID: { text: 'Confirmé', color: 'success' },
    FRAUD: { text: 'Fraude', color: 'warning' },
    FAILED: { text: 'Echec', color: 'failure' },
    CANCELED: { text: 'Annulé', color: 'dark' },
    CHECKING: { text: 'Traitement', color: 'info' }
  }

}

export default Consts;